import { html } from '@microsoft/fast-element';

export const progressBarTemplate = html`
    <div class="progressBar"></div>
`;
